import { CONFIG } from './config'

export const VALIDGUESSES = [    
  'niyam',
  "loma'",
  'ciira',
  'anini',
  'lotok',
  'nanom',
  'tayal',
  'kilang',
  'kapah',
  'panay',
  'sowal',
  'fodoy',
  'lalan',
  'naira',
  'awaay',
  'kolong',
  'tireng',
  'singsi',
  'kamay',
  'foting',
  'caira',
  'mayaw',
  'demak',
  'fafoy',
  'codad',
  "'ayam",
  'cecay',
  "'ayaw",
  'kacaw',
  'adada',
  'riyar',
  "'orip",
  'hemay',
  "wa'ay",
  "to'as",
  'rakat',
  'tayra',
  'sapad',
  'fanaw',
  'pising',
  'dafak',
  'kapot',
  'payso',
  'kawas',
  'kaying',
  'lafang',
  'fiyaw',
  'sanay',
  'tangal',
  'potal',
  'tomok',
  'kasoy',
  'tomay',
  "'awol",
  "'orad",
  'cidal',
  "doka'",
  "'oner",
  'widang',
  'hawan',
  'dateng',
  'pawli',
  'fokes',
  'miala',
  'felac',
  'tayni',
  "'icep",
  'semot',
  "fana'",
  'piyang',
  "nga'ay",
  "po'ot",
  'papah',
  'pawti',
  'mamang',
  'wadis',
  'impic',
  'tiyad',
  'kolas',
  'itini',
  'cacay',
  'kikay',
  'radiw',
  'cengel',
  "riko'",
  'lamal',
  "maro'",
  'ngangan',
  'dangah',
  'niira',
  'folad',
  "koko'",
  'parod',
  'dipot',
  'lawac',
  'simal',
  'toray',
  'foday',
  'roray',
  'nanay',
  'itiya',
  'facal',
  'namoh',
  'inaan',
  'howak',
  'kohaw',
  'tawki',
  'ripon',
  'kafang',
  'dofot',
  "folo'",
  'tefos',
  'raraw',
  'lahok',
  'fonon',
  'hanto',
  'kolang',
  'capox',
  'cafeng',
  'cilah',
  'dingki',
  'rikor',
  'selal',
  'terong',
  "'oway",
  'patay',
  'kafong',
  'fonos',
  'cangaw',
  "mami'",
  'tefon',
  'safaw',
  'totoy',
  'lotong',
  'pacek',
  'kimad',
  'wirok',
  'rinom',
  "cepi'",
  'fanoh',
  'siraw',
  'cofel',
  'sinsi',
  'lakaw',
  "ngiha'",
  "fila'",
  'sinar',
  'lonen',
  'lingko',
  'liyad',
  'safon',
  'rengos',
  "polo'",
  'tokay',
  'lifon',
  'lonan',
  'pitaw',
  "foti'",
  'marad',
  'holam',
  'hafay',
  'lipay',
  'tofor',
  'laeno',
  'lefok',
  "'amis",
  'wikol',
  'fonak',
  "fo'is",
  "kowa'",
  'ratoh',
  "ngoso'",
  'herek',
  'lengaw',
  'hekal',
  "'okak",
  'yofin',
  'tadah',
  'paliw',
  'maala',
  "lesa'",
  'sanek',
  'dakoc',
  'fanges',
  'amoto',
  'takaw',
  'sepat',
  'kofoc',
  'cekok',
  "li'el",
  'likat',
  'lowad',
  'itira',
  'kowang',
  'fotod',
  "'osaw",
  'cikaf',
  'cohel',
  'polol',
  'hacol',
  'lalok',
  'mama^',
  'falah',
  'katol',
  "'onip",
  'masay',
  'nanges',
  "para'",
  'patih',
  'kongko',
  'keliw',
  'laway',
  "'opic",
  "tayi'",
  "fala'",
  "tefo'",
  'kahot',
  "karo'",
  'lasang',
  'posong',
  'kaeca',
  "ca'ang",
  'cokor',
  'losid',
  'mahod',
  'cedet',
  'cahid',
  'hecek',
  'lisin',
  'fangas',
  "moco'",
  'dipong',
  'dongec',
  'tosor',
  'cekiw',
  'kadit',
  'kapal',
  'remes',
  'likes',
  'kayki',
  "lodi'",
  'cicax',
  'cirot',
  "'idoc",
  "demi'",
  'podac',
  'cifar',
  'tilid',
  'kalong',
  'nakaw',
  'tolok',
  'tipos',
  "da'ci",
  'lapot',
  'do^do',
  'fiher',
  'kerah',
  'lidong',
  'fadas',
  'fekac',
  'kalang',
  'payci',
  "fiwa'",
  'losay',
  'hemot',
  'lafii',
  'iraay',
  'namal',
  'rafar',
  'kaniw',
  'pades',
  'tingwa',
  'rakes',
  'lingad',
  'ngoyos',
  'sikal',
  'manto',
  'riwang',
  'koror',
  "sanga'",
  'pinang',
  'parad',
  'aciya',
  "sopa'",
  'adahi',
  "'odot",
  'alaen',
  'ngasaw',
  'kadang',
  'toyaw',
  "sota'",
  'kalas',
  "'olid",
  'piala',
  'kodic',
  'cafay',
  'rawac',
  'citing',
  'tawho',
  'calay',
  'kingko',
  'canem',
  'cangra',
  'letep',
  'fasaw',
  "ca'of",
  'licay',
  "ca'or",
  'dafong',
  'nangra',
  'cawang',
  'fokil',
  'cedas',
  'kokong',
  'cefang',
  'cekem',
  "ceka'",
  'nonol',
  'roroh',
  'celak',
  'linay',
  'datay',
  "celi'",
  "cengo'",
  "ceno'",
  "cepa'",
  "cepo'",
  'kicon',
  'talaw',
  'fesol',
  "'akong",
  'cidek',
  'lodak',
  "peco'",
  'yakiw',
  'mangah',
  'cikay',
  'ciker',
  "'alol",
  'cimil',
  'takao',
  'cinco',
  'cipat',
  'salil',
  "ca'ay",
  'co^co',
  "co'ay",
  'rorong',
  'pecih',
  'kocong',
  'codah',
  "co'ong",
  'dakaw',
  'damay',
  "da'oc",
  "'onoc",
  'dihif',
  'koreng',
  'poton',
  'ngayaw',
  'felec',
  "'odang",
  'liteng',
  'panco',
  'fadic',
  'lepel',
  'fakar',
  'fakong',
  "la'ed",
  'cokap',
  'folod',
  'firang',
  'talod',
  'fanol',
  'keter',
  'hongay',
  'felih',
  'lamit',
  'ficin',
  'rarem',
  'talip',
  'focod',
  "pana'",
  "'oning",
  'teker',
  'fongoh',
  'fotek',
  'tolas',
  'liyok',
  'lafin',
  'helong',
  'icifa',
  'taneng',
  'timol',
  'talid',
  'lawad',
  'kaciw',
  "'imer",
  'kafer',
  'kafit',
  'kafel',
  "'akik",
  'rinon',
  'tingki',
  'kalim',
  "'ingay",
  'tapang',
  'tahaf',
  'yoyang',
  "'olic",
  'rohem',
  "em'em",
  'kedal',
  'kelac',
  'keling',
  'kilac',
  'lifot',
  'kitoh',
  'kiwli',
  "'apol",
  'kolay',
  'konis',
  'tiring',
  'polin',
  'wacay',
  'lemed',
  "losa'",
  'rarong',
  'tokos',
  "na'ay",
  'posak',
  'toron',
  'madah',
  'miming',
  'piyaw',
  'nafoy',
  'kawos',
  'kawil',
  'seking',
  'sayho',
  'ngalay',
  'ngoset',
  'parok',
  'yosang',
  'sinang',
  'rarom',
  "ri'ang",
  'tangic',
  "'acaw",
  'akian',
  "fowa'",
  'fotos',
  "'adit",
  'fongah',
  'aenem',
  "sa'om",
  'kidong',
  'kaala',
  "cica'",
  'alapi',
  'fahal',
  'amoot',
  'anaya',
  'angcoh',
  'angpaw',
  'fisac',
  "'acis",
  "aoto'",
  'ap^ap',
  'araaw',
  'arapo',
  'irari',
  'piati',
  'laliw',
  'nanaw',
  'hanen',
  'cacak',
  'tanam',
  "moli'",
  'tadek',
  'fetik',
  'tangki',
  'repon',
  'cadiw',
  "'emek",
  'cadok',
  'compo',
  'cidap',
  'cafer',
  'fesoc',
  "cafi'",
  'cahiw',
  "li'ay",
  "ca'it",
  'si^oy',
  'caito',
  'cakay',
  'cakil',
  "tono'",
  "cala'",
  'calap',
  'caleng',
  'caliw',
  'caloh',
  'camol',
  "'afih",
  'cangal',
  "capa'",
  'capet',
  "capo'",
  'sokon',
  'cawhi',
  'longec',
  'cawka',
  'cayat',
  'cayna',
  'tekop',
  'cedam',
  'cedem',
  'foksi',
  "cedo'",
  'cefis',
  'cefos',
  'kanas',
  'cekel',
  'cekil',
  'cekor',
  'riyad',
  'cekos',
  'celed',
  'celem',
  'cemet',
  "cena'",
  'cengaw',
  'hilam',
  'cepet',
  'posko',
  'cerem',
  "'owang",
  "'oles",
  'ceris',
  'lipot',
  'ceror',
  'ci^ci',
  'cicih',
  'cicir',
  'ciciw',
  'cidem',
  "ci'em",
  "ci'ep",
  "pi'iw",
  "ci'im",
  "'alaw",
  'cikeng',
  'cikil',
  'yosan',
  "'atay",
  'cinas',
  'tangso',
  'cingki',
  'mamag',
  'cipoh',
  'cirid',
  'liyaw',
  "'otoc",
  "ciyo'",
  "co'af",
  'cocok',
  'cocop',
  'siping',
  "co'ed",
  "co'ep",
  'cofay',
  'yofing',
  'kofong',
  'cohong',
  "co'is",
  'ramet',
  'cokay',
  'coker',
  'cokis',
  'colal',
  'nokay',
  'coled',
  'colek',
  "colo'",
  'colok',
  'comod',
  'fayang',
  'conoh',
  "'odal",
  'salang',
  "cora'",
  'coraf',
  'corah',
  'corok',
  'cowat',
  'coyoh',
  "da'ad",
  'kapat',
  "dado'",
  "noli'",
  'dadoy',
  'ratar',
  'hacok',
  'dangka',
  'dangoy',
  'datok',
  "'alic",
  'dayom',
  'defit',
  'defong',
  'kedang',
  "'engid",
  'dinget',
  "dita'",
  'ditek',
  'docoh',
  'dodang',
  'kodih',
  'dodoh',
  "do'eng",
  "do'es",
  'ramot',
  'fangec',
  'raway',
  'hinom',
  'dopoh',
  'dotoc',
  'layap',
  'el^el',
  'langih',
  'engaan',
  "'enor",
  'likid',
  'es^es',
  'hepik',
  "faca'",
  "fadi'",
  'fadil',
  'hemin',
  'fafaw',
  'dofang',
  'fahoy',
  'faking',
  'falat',
  'faled',
  'falic',
  'latek',
  'falod',
  'lahad',
  'dengan',
  'kesip',
  "'oteng",
  'fangad',
  'fangto',
  'faniw',
  'fariw',
  'fasal',
  'fatac',
  'fatis',
  'fawah',
  "fayo'",
  'felot',
  'fetak',
  'fetas',
  "fena'",
  'fetir',
  'fidac',
  'fidang',
  'fihid',
  'fihon',
  "fi'ik",
  'fison',
  'fitay',
  'fiting',
  'fiyac',
  'fiyok',
  'focol',
  "'opih",
  'fohad',
  'fohat',
  'fohet',
  'fohid',
  'fokaw',
  'folang',
  'fonor',
  "fo'ot",
  'akaka',
  'foraw',
  'lileng',
  'konon',
  "reda'",
  'fowah',
  'fowak',
  'cikaw',
  "fowi'",
  'tiyan',
  'foyol',
  'mihai',
  'alomi',
  'piesa',
  'hales',
  'efiyo',
  'linot',
  'hater',
  'hawad',
  'hawang',
  'hayda',
  'hecep',
  'facel',
  'tasiy',
  'hedot',
  'hefong',
  'helop',
  'walay',
  'hemek',
  'hengad',
  'henot',
  'hepol',
  'hetec',
  "'oled",
  'hecra',
  'hifang',
  'totok',
  'himaw',
  'himed',
  'hinac',
  'hinam',
  'hineng',
  'hitay',
  'hodoc',
  'hofoc',
  'titio',
  'holol',
  'homong',
  'hongko',
  'hongti',
  'ihoni',
  'horac',
  'howad',
  'icowa',
  'tapid',
  "'iwas",
  'idahi',
  "ngowi'",
  'inaaw',
  'nohir',
  'inain',
  'paini',
  'iraan',
  'lifet',
  'is^is',
  'tepad',
  'lefot',
  'lengad',
  'pawan',
  'kadat',
  'kadoh',
  'kadom',
  'koria',
  'rapic',
  'keped',
  'kedec',
  'kafos',
  'setek',
  "'eric",
  'nayat',
  "ta'ong",
  'caway',
  'kakoy',
  'kalah',
  'tayto',
  'kalat',
  'hinang',
  'kalaw',
  'kales',
  'kalic',
  'kamec',
  'kamok',
  'rakam',
  'ringer',
  'kangic',
  "kani'",
  'kappa',
  'koraw',
  'kiwit',
  'terep',
  'karong',
  'kawal',
  'kawaw',
  'kayang',
  'kayap',
  'kayat',
  'safa^',
  'kecec',
  'kefeng',
  'kefing',
  'kefoh',
  "tepi'",
  'kemot',
  'kenaw',
  "keni'",
  'kereng',
  'kerid',
  'kerit',
  'mokin',
  'kesem',
  'siday',
  "kesi'",
  'keting',
  'keton',
  'kicay',
  'kihar',
  'kilim',
  'kiling',
  'kinih',
  'kining',
  'kippo',
  "kiri'",
  'kiting',
  'renges',
  "'icang",
  'kiyam',
  "ca'ol",
  'kiyot',
  "'afar",
  'kodoh',
  'kofaw',
  'kofel',
  'kofit',
  'kokang',
  'kokot',
  'kolac',
  'kolit',
  'sepel',
  'komod',
  'koling',
  'konoc',
  'kopit',
  'korac',
  'koring',
  "tedi'",
  'kosiw',
  'kotay',
  'kotem',
  "koti'",
  'kowad',
  'kowan',
  'kowaw',
  'koyod',
  "tama'",
  'fangko',
  'lacal',
  'laciw',
  "lada'",
  'cinah',
  'oraor',
  'lahod',
  'lakec',
  'datong',
  'diway',
  'lakis',
  "lala'",
  'lalang',
  'anglis',
  'lalat',
  "tilo'",
  'neneng',
  "'owid",
  'limit',
  'dofod',
  'langto',
  'lasak',
  "'owak",
  'latak',
  'lawal',
  'lawit',
  'lawla',
  'lawop',
  'laying',
  'lecad',
  'lecep',
  'leneng',
  'lengac',
  'sorit',
  "'iyok",
  'lepet',
  'lidep',
  'tarang',
  'lihaf',
  'lihay',
  'likaf',
  'liked',
  'likot',
  "toro'",
  'lilam',
  'lilid',
  'lilis',
  'liloc',
  'limaw',
  'limek',
  'lingwa',
  "liso'",
  "liti'",
  'litod',
  'liwal',
  'liway',
  'liyang',
  'liyas',
  'liyoc',
  'liyon',
  "loci'",
  'lofic',
  'lofoc',
  'lokes',
  'lokot',
  'lolod',
  'longoc',
  'lonok',
  'lopas',
  'ataya',
  'losok',
  'lotac',
  'lowan',
  "lowi'",
  'lowid',
  'kaeso',
  'wayya',
  "na'on",
  "pili'",
  "'ikay",
  'alofo',
  "'oyas",
  "'atep",
  "rilo'",
  'radaw',
  'wakang',
  'koris',
  'sonan',
  'tenged',
  'dofoc',
  'siwto',
  'matang',
  'lokat',
  'rapor',
  'melet',
  'menek',
  'metek',
  'mi^mi',
  'takid',
  'miosa',
  'domong',
  'fotol',
  "misi'",
  'tadok',
  'la^pa',
  'tapad',
  'cafong',
  'totang',
  'omela',
  'miyat',
  'modac',
  "moso'",
  "na'ang",
  'peleng',
  'petek',
  'nanam',
  "la'ad",
  'dayna',
  'nikar',
  'nikaw',
  "'isaf",
  "ngala'",
  "'oipc",
  'ngalef',
  "ngawa'",
  "ngawi'",
  "ngici'",
  'ngingoy',
  'cofer',
  'ngiriw',
  'ngitid',
  "ngito'",
  'ngohah',
  'ngohed',
  'oh^oh',
  'titit',
  'on^on',
  'ong^ong',
  'or^or',
  'micep',
  'lamay',
  'padang',
  "'anof",
  'niama',
  'mising',
  'kakiw',
  "tera'",
  'todang',
  'ronang',
  'patek',
  'pedoc',
  "pela'",
  'peric',
  'kinan',
  "'etal",
  "'akok",
  'miaca',
  'piyak',
  'piyok',
  'podek',
  'pohaw',
  'cayto',
  'polong',
  "poni'",
  'porang',
  'radom',
  'rafac',
  'rafas',
  'tangko',
  'rahid',
  'rahod',
  'rakar',
  'ramod',
  'ranam',
  "rara'",
  'rarar',
  'rarid',
  'rasit',
  'rawang',
  'rawis',
  'refong',
  'rekad',
  'reken',
  'rekoh',
  'renaf',
  'renec',
  'renok',
  'resap',
  'rihaw',
  'rihong',
  'rikec',
  "rina'",
  "ripa'",
  "riri'",
  'ririd',
  'riting',
  'ritos',
  'rocek',
  'rocod',
  'rocok',
  'tenok',
  'rodis',
  'riray',
  'waneng',
  'romot',
  'ronic',
  'ronong',
  'ropay',
  'rorang',
  'rorok',
  'sadak',
  'safak',
  'safel',
  'sawad',
  "seka'",
  "sela'",
  'senger',
  'sepal',
  'setol',
  "'okot",
  'simed',
  'somal',
  'sisit',
  'niara',
  'siwar',
  'so^so',
  "so'aw",
  'sofoc',
  'niina',
  "so'or",
  "so'ot",
  'soped',
  'sorar',
  "ta'ak",
  "ta'ang",
  'tadem',
  "'araw",
  'tahka',
  'talem',
  'taloc',
  'tamek',
  "tana'",
  "tapa'",
  'tapay',
  'fatad',
  'tawal',
  'tedal',
  'tefad',
  'tefoc',
  'tekep',
  'tekol',
  'telang',
  'telaw',
  'telec',
  'telii',
  'tenas',
  'dafah',
  'tengil',
  'terik',
  'rihom',
  'tiraw',
  'tiyam',
  'todoh',
  "lama'",
  'todong',
  "to'em",
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
